import { allFilterTypes } from "@shared/services/filters";

import type { QuickOrderListAdParams } from "@shared/types/QuickOrderList";

export const determineListAdParams = (
  stateParams: any,
  listFilters: any
): QuickOrderListAdParams => {
  const data: any = {};

  if (stateParams.search) {
    data.search = stateParams.search;
  }

  if (stateParams.category) {
    data.category_id = [parseInt(stateParams.category)];
  } else {
    data.category_id = listFilters?.categories?.map(c => c.id);
  }

  if (stateParams.distributor) {
    const distributorId = listFilters?.distributors?.find(
      d => d.name === stateParams.distributor
    )?.id;
    if (distributorId) {
      data.distributor_ids = [distributorId];
    }
  } else {
    data.distributor_ids = listFilters?.distributors?.map(d => d.id);
  }

  return data;
};

export const listCarouselLink = (params: QuickOrderListAdParams): string => {
  const { category_id, distributor_ids, search } = params;
  if (!category_id && !distributor_ids && !search) {
    return;
  }

  let link = "/product_listing?";

  if (category_id) {
    const categoryParam = allFilterTypes.find(f => f.id === "category").param;
    category_id.sort().forEach(c => {
      link += `&${categoryParam}=${c}`;
    });
  }

  if (distributor_ids) {
    const distributorParam = allFilterTypes.find(f => f.id === "distributor").param;
    distributor_ids.sort().forEach(d => {
      link += `&${distributorParam}=${d}`;
    });
  }

  if (search) {
    link += `&search=${encodeURIComponent(search)}`;
  }

  return link;
};
